import './confirm'
import './copy'
import './direct_uploads'
import './lazysrc'
import './timezone'
import './health_monitor'

// This prevents our scripts from failing if Plausible is blocked by an adblocker
import('./plausible').then(({ initPlausible }) => {
  initPlausible()
})

// Initialize Mermaid for diagram rendering
import('./mermaid').then(({ initMermaid }) => {
  initMermaid()
}).catch(error => {
  console.error('Failed to load Mermaid:', error)
})
